import { defineComponent, getCurrentInstance, onMounted, useCssModule, useRouter } from '@nuxtjs/composition-api';
import { enableRouterForDOMLinks, parseLinksInString } from '~/utils';
export default defineComponent({
    name: 'BoxHeading',
    props: {
        box: {
            required: true,
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Instance.
         */
        const instance = getCurrentInstance();
        /**
         * Router.
         */
        const router = useRouter();
        onMounted(() => {
            if (!instance.proxy.$el) {
                return;
            }
            enableRouterForDOMLinks({
                target: instance.proxy.$el,
                router,
            });
        });
        return {
            css,
            parseLinksInString,
        };
    },
});
